var map = {
	"./bridge/bridge_brand_logo.png": "81c9a",
	"./bridge/bridge_logo.png": "41f9",
	"./images/dankoff_logo.png": "3215",
	"./images/hermelin_brand_logo.png": "5c43",
	"./lacava/lacava_brand_logo.png": "e86e",
	"./lacava/lacava_logo.png": "af4d",
	"./slow/slow_brand_logo.png": "9ea0",
	"./slow/slow_logo.png": "cc1f",
	"./smilingFaces/smilingFaces_brand_logo.png": "aea7",
	"./smilingFaces/smilingFaces_logo.png": "a63d",
	"./stellini/stellini_brand_logo.png": "0cd7",
	"./stellini/stellini_logo.png": "6862",
	"./verdi/verdi_brand_logo.png": "ef51",
	"./verdi/verdi_logo.png": "d682"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08ce";